import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  return result.map(m => ({ label: m.userName, value: m.userId }))
}
export function useUserOptions(inspirationId) {
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchUsers()
  }, [inspirationId])
  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector', { params: { inspirationId } })
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }
  return options
}
export default (props) => {
  const { inspirationId, placement, placeholder = '采集用户', ...otherProps } = props
  const options = useUserOptions(inspirationId)
  return <Select placement={placement} multi {...otherProps} data={options} placeholder={placeholder} />
}
